// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Ldpf","cell":"ColumnAccessor_cell__1P2Pr","firstCellAccent":"ColumnAccessor_firstCellAccent__1XbMz"};